<template>
  <div class="photoModel">
    <div ref="photoModel" class="photo" id="photoModel"></div>
  </div>
</template>

<script>
import { Viewer } from '@photo-sphere-viewer/core';
export default {
  mounted() {
    new Viewer({
      container: this.$refs.photoModel,
      panorama: this.$route.query.src,
    });
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import '~@photo-sphere-viewer/core/index.css';
.photoModel {
	width: 100%;
	height: 100vh;
	.photo {
    width: 100%;
    height: 100%;
	}
}
</style>
